import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card-group d-flex justify-content-left justify-content-lg-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_file = _resolveComponent("file")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file) => {
      return (_openBlock(), _createBlock(_component_file, {
        key: file._id,
        file: file
      }, null, 8, ["file"]))
    }), 128))
  ]))
}